import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import {
    Box,
    Button,
    CircularProgress,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
} from "@mui/material";
import { toastMessage } from "utils/toastMessage";
import { Toaster } from "react-hot-toast";
import { uploadDocuments } from "_controllers/officer";
import axios from "axios";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AddIcon from "@mui/icons-material/Add";
import dotenv from "dotenv";
import { useHistory } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import authAxios from "setups/axios";
import { PageHeader, SectionCard, EmptyState } from "_shared/ui";

dotenv.config();

const Main = () => {
    const navigate = useHistory()

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [image, setImage] = useState('')

    useEffect(async () => {
        const requests = await uploadDocuments();
        setData(requests?.docs);
        setLoading(true);
    }, [message])

    const handleImage = async (category) => {
        console.log("object", category);
        const formData = new FormData();
        formData.append("file", image);
        formData.append("fileName", image.name);
        formData.append("type", category)
        const token = localStorage.getItem("token");
        const config = {
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
        const url = process.env.REACT_APP_REQUEST_ENDPOINT
        await axios.post(
            `${url}/api/v1/document/upload`,
            formData, config
        ).then((res) => {
            setImage('')
            setMessage(res?.data?.message)
            toastMessage(res?.data?.message, "success");
        }).catch((err) => {
            setImage('')
            setMessage(err?.message)
            toastMessage("Select File First.", "error");
        });
    };

    const saveImg = (e) => {
        setImage(e.target.files[0]);
    };

    const handleDelete = async (id) => {
        const response = await authAxios()({
            url: `/api/v1/document/${id}`,
            method: "DELETE",
        });
        toastMessage(response.data.message, "success")
        setMessage(response?.data.message);
    }

    return (
        <>
            <PageHeader
                title="Upload Documents"
                subtitle="Manage documents available across the organization"
                action={
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => navigate.push('/add-documents')}
                    >
                        Add Document
                    </Button>
                }
            />

            {loading ? (
                <SectionCard disablePadding>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Document Type</TableCell>
                                    <TableCell align="left">Description</TableCell>
                                    <TableCell align="center">Uploaded Doc</TableCell>
                                    <TableCell align="center">Last Upload On</TableCell>
                                    <TableCell align="center">Action</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {data && data?.length > 0
                                    ? data?.map((d) => (
                                        <TableRow key={d._id}>
                                            <TableCell align="left">{d?.documentCategory}</TableCell>
                                            <TableCell align="left">{d?.description}</TableCell>
                                            <TableCell align="center">
                                                <Tooltip title="View document">
                                                    <IconButton
                                                        component={Link}
                                                        href={d?.url}
                                                        target="_blank"
                                                        rel="noopener"
                                                        color="primary"
                                                    >
                                                        <PictureAsPdfIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="center">{d?.dateUploaded.slice(0, 10)}</TableCell>
                                            <TableCell align="center">
                                                <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                                                    <Tooltip title="Edit">
                                                        <IconButton
                                                            color="success"
                                                            onClick={() => navigate.push(`/upload-documents/edit/${d._id}`)}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete">
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => handleDelete(d._id)}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                    : (
                                        <TableRow>
                                            <TableCell colSpan={5} sx={{ border: "none" }}>
                                                <EmptyState
                                                    title="No documents available"
                                                    description="Uploaded documents will appear here once added."
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </SectionCard>
            ) : (
                <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                    <CircularProgress />
                </Box>
            )}
        </>
    );
};

const Upload = () => {
    return (
        <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
            <DashGridL2 Top={TopBar} Main={Main} />
            <Toaster />
        </AccessController>
    );
};

export default Upload;
